// @ts-check
import BlockCard from '../BlockCard';

/**
 * Returns & exchanges is untracked until the returns-exchanges branch is merged; the backend sends only
 * { untracked: true, href } and the page normally renders the untracked card itself. This is the registry entry.
 * @param {{ block: { href?: string } }} props
 */
export default function ReturnsBlock({ block }) {
  return <BlockCard title="Returns & exchanges" href={block?.href || '/orders'} state="untracked" />;
}
